import type { FC } from 'react';

import { Modal } from '@skillarea/lib-frontend';

import type { IGameLayoutLabels } from '../../labels';

import styles from './SurrenderDialog.module.scss';

interface ISurrenderDialogProps {
  isOpen: boolean;
  labels: IGameLayoutLabels['surrenderDialog'];
  onKeepPlaying: () => void;
  onSurrender: () => void;
}

export const SurrenderDialog: FC<ISurrenderDialogProps> = ({
  isOpen,
  labels,
  onKeepPlaying,
  onSurrender,
}) => {
  return (
    <Modal
      isOpen={isOpen}
      isAutoClosing={false}
      onBeforeClose={onKeepPlaying}
      title={labels.title}
      classNameModal={styles.dialogContent}
    >
      <h2 className={styles.title}>{labels.title}</h2>
      <div className={styles.divider} />
      <p className={styles.description}>{labels.description}</p>
      <div className={styles.buttons}>
        <button
          type="button"
          className={styles.keepPlayingButton}
          onClick={onKeepPlaying}
        >
          {labels.keepPlaying}
        </button>
        <button
          type="button"
          className={styles.surrenderButton}
          onClick={onSurrender}
        >
          {labels.surrender}
        </button>
      </div>
    </Modal>
  );
};
